import React, { useState, useEffect } from 'react'
import { FormGroup, Panel, Input, InputGroup, Icon, ControlLabel } from 'rsuite'
import { Grid, Row, Col } from 'rsuite'
import { Form, Radio, RadioGroup, DatePicker } from 'rsuite'
import { isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import moment from 'moment'
import NumberFormat from 'react-number-format'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'

export default function ProjectTypeGroup({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
}) {
  const calMonth = (date, type) => {
    let startData = type == 'start' ? date : getValues(schema.workingTime.startDate.name)
    let endData = type == 'end' ? date : getValues(schema.workingTime.endDate.name)
    if (startData && endData) {
      let range = moment(endData).diff(moment(startData), 'months', true)
      setValue(schema.workingTime.monthCount.name, range.toFixed(0).toString())
    }
  }

  const onChangeProjectFeature = (value) => {
    setValue(schema.projectFeature.name, value)
    clearErrors(schema.projectFeature.name)
  }

  const onChangeOfferFunded = (value) => {
    setValue(schema.offerFunded.name, value)
    clearErrors(schema.offerFunded.name)
  }

  const projectFeaturePanel = () => {
    return (
      <Panel header={requiredFiled(schema.projectFeature.validators, schema.projectFeature.label)}>
        <Grid fluid>
          <ErrorMessage error={errors[schema.projectFeature.name]} />

          <Controller
            key={schema.projectFeature.name}
            name={schema.projectFeature.name}
            control={control}
            rules={isValidators(schema.projectFeature.validators)}
            defaultValue={schema.projectFeature.value}
            render={(props) => {
              return (
                <RadioGroup inline value={props.value} onChange={onChangeProjectFeature}>
                  {schema.projectFeature.options.map((item, index) => {
                    return (
                      <Radio
                        key={index}
                        disabled={schema.projectFeature.disabled}
                        name={item.name}
                        value={item.value}
                      >
                        {item.label}
                      </Radio>
                    )
                  })}
                </RadioGroup>
              )
            }}
          ></Controller>
        </Grid>
      </Panel>
    )
  }

  const offerFundedPanel = () => {
    return (
      <Panel header={requiredFiled(schema.offerFunded.validators, schema.offerFunded.label)}>
        <ErrorMessage error={errors[schema.offerFunded.name]} />

        <Controller
          key={schema.offerFunded.name}
          name={schema.offerFunded.name}
          control={control}
          rules={isValidators(schema.offerFunded.validators)}
          defaultValue={schema.offerFunded.value}
          render={(props) => {
            return (
              <RadioGroup
                inline
                disabled={schema.offerFunded.disabled}
                value={props.value}
                onChange={onChangeOfferFunded}
              >
                {schema.offerFunded.options.map((item, index) => {
                  return (
                    <Radio key={index} name={item.name} value={item.value}>
                      {item.label}
                    </Radio>
                  )
                })}
              </RadioGroup>
            )
          }}
        ></Controller>
      </Panel>
    )
  }

  const workingTimePanel = () => {
    return (
      <Panel header={requiredFiled(schema.workingTime.validators, schema.workingTime.label)}>
        <Row>
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={schema.workingTime.projectReportDay ? 6 : 8}
            style={{ width: 260 }}
          >
            <ErrorMessage error={errors[schema.workingTime.startDate.name]} />
            <ControlLabel>
              {' '}
              {requiredFiled(
                schema.workingTime.startDate.validators,
                schema.workingTime.startDate.label
              )}
            </ControlLabel>
            <Controller
              key={schema.workingTime.startDate.name}
              name={schema.workingTime.startDate.name}
              control={control}
              rules={isValidators(schema.workingTime.startDate.validators)}
              defaultValue={schema.workingTime.startDate.value}
              render={(props) => {
                return (
                  <DatePicker
                    format={DATE_PICKER_FORMAT}
                    locale={LOCAL_DAY_TH}
                    block
                    appearance="subtle"
                    placement="auto"
                    disabled={schema.workingTime.startDate.disabled}
                    disabledDate={(date) =>
                      (getValues(schema.workingTime.endDate.name) &&
                        moment(getValues(schema.workingTime.endDate.name)).isBefore(
                          date,
                          new Date()
                        )) ||
                      moment(schema.workingTime.mainStartDate).isAfter(date, new Date()) ||
                      moment(schema.workingTime.mainEndDate)
                        .add(1, 'days')
                        .isBefore(date, new Date())
                    }
                    value={props.value}
                    onChange={(value) => {
                      let date
                      value && (date = value.toLocaleDateString('en-ZA'))
                      calMonth(value, 'start')
                      setValue(schema.workingTime.startDate.name, date)
                      clearErrors(schema.workingTime.startDate.name)
                    }}
                    onClean={() => {
                      setValue(schema.workingTime.startDate.name)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={schema.workingTime.projectReportDay ? 6 : 8}
            style={{ width: 260 }}
          >
            <ErrorMessage error={errors[schema.workingTime.endDate.name]} />
            <ControlLabel>
              {requiredFiled(
                schema.workingTime.endDate.validators,
                schema.workingTime.endDate.label
              )}
            </ControlLabel>
            <Controller
              key={schema.workingTime.endDate.name}
              name={schema.workingTime.endDate.name}
              control={control}
              rules={isValidators(schema.workingTime.endDate.validators)}
              defaultValue={schema.workingTime.endDate.value}
              render={(props) => {
                return (
                  <DatePicker
                    format={DATE_PICKER_FORMAT}
                    locale={LOCAL_DAY_TH}
                    block
                    appearance="subtle"
                    placement="auto"
                    disabled={schema.workingTime.endDate.disabled}
                    disabledDate={(date) =>
                      (getValues(schema.workingTime.startDate.name) &&
                        moment(getValues(schema.workingTime.startDate.name)).isAfter(
                          date,
                          new Date()
                        )) ||
                      moment(schema.workingTime.mainStartDate).isAfter(date, new Date()) ||
                      moment(schema.workingTime.mainEndDate).isBefore(date, new Date())
                    }
                    name={schema.workingTime.endDate.name}
                    value={props.value}
                    onChange={(value) => {
                      let date
                      value && (date = value.toLocaleDateString('en-ZA'))
                      calMonth(value, 'end')
                      setValue(schema.workingTime.endDate.name, date)
                      clearErrors(schema.workingTime.endDate.name)
                    }}
                    onClean={() => {
                      setValue(schema.workingTime.endDate.name)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={schema.workingTime.projectReportDay ? 6 : 8}
            style={{ width: 150 }}
          >
            <ErrorMessage error={errors[schema.workingTime.monthCount.name]} />
            <ControlLabel>
              {requiredFiled(
                schema.workingTime.monthCount.validators,
                schema.workingTime.monthCount.label
              )}
            </ControlLabel>
            <Controller
              key={schema.workingTime.monthCount.name}
              name={schema.workingTime.monthCount.name}
              control={control}
              rules={isValidators(schema.workingTime.monthCount.validators)}
              defaultValue={schema.workingTime.monthCount.value}
              render={(props) => {
                return (
                  <NumberFormat
                    className="rs-input"
                    disabled={schema.workingTime.monthCount.disabled}
                    placeholder={schema.workingTime.monthCount.hint}
                    thousandSeparator={true}
                    value={props.value}
                    onValueChange={(value) => {
                      props.onChange(value.floatValue)
                    }}
                  />
                )
              }}
            />
          </Col>
          {/* {schema.workingTime.projectReportDay && (
            <Col xs={24} sm={12} md={8} lg={6} style={{ width: 230 }}>
              <ErrorMessage error={errors[schema.workingTime.projectReportDay.name]} />
              <ControlLabel>
                {requiredFiled(
                  schema.workingTime.projectReportDay.validators,
                  schema.workingTime.projectReportDay.label
                )}
              </ControlLabel>
              <Controller
                key={schema.workingTime.projectReportDay.name}
                name={schema.workingTime.projectReportDay.name}
                control={control}
                rules={isValidators(schema.workingTime.projectReportDay.validators)}
                defaultValue={schema.workingTime.projectReportDay.value}
                render={(props) => {
                  return (
                    <NumberFormat
                      className="rs-input"
                      disabled={schema.workingTime.projectReportDay.disabled}
                      placeholder={schema.workingTime.projectReportDay.hint}
                      thousandSeparator={true}
                      value={props.value}
                      onValueChange={(value) => {
                        props.onChange(value.floatValue)
                      }}
                    />
                  )
                }}
              />
            </Col>
          )} */}
        </Row>
      </Panel>
    )
  }

  return (
    <div>
      <Form>
        <Panel collapsible defaultExpanded bodyFill>
          <Grid fluid>
            <FormGroup controlId="projecttypegroup">
              {projectFeaturePanel()}
              {/* {projectTypePanel()} */}
              {offerFundedPanel()}
              {workingTimePanel()}
            </FormGroup>
          </Grid>
        </Panel>
      </Form>
    </div>
  )
}
